<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <UserList></UserList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Users",
  data: () => ({
    page: {
      title: "Users"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Users",
        disabled: true
      }
    ]
  }),
  components: {
    UserList: () => import("../components/UserList.vue")
  },
  methods: {},
  mounted: async function() {}
};
</script>
